module.exports = __webpack_public_path__ + "img/order_img1.886a2d53.png";